<template>
  <div id="app" class="font-rubik bg-white min-h-screen">
  <component :is="layoutName">
      <router-view/>
      <div v-show="isLoading" class="fixed inset-0 z-[9999] flex items-center flex-col gap-2 justify-center bg-white/80 backdrop-blur">
  <span class="relative flex h-16 w-16">
    <span class="animate-spin absolute inline-flex h-full w-full rounded-full opacity-30"></span>
    <span class="relative inline-flex rounded-full h-16 w-16 items-center justify-center">
      <svg class="h-8 w-8 text-[#00cdac] animate-spin" viewBox="0 0 24 24" fill="none">
        <circle class="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
        <path d="M22 12a10 10 0 01-10 10" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
      </svg>
    </span>
  </span>
  <span class="  w-full text-center text-main text-base">Loading...</span>
</div>
    </component>
    <PWAInstallPrompt />
  </div>
</template>
<script>
import DefaultLayout from './layouts/Default'
import LoginLayout from './layouts/Login'
import PWAInstallPrompt from './components/Common/PWAInstallPrompt.vue'
export default {
  components: {
    DefaultLayout,
    LoginLayout,
    PWAInstallPrompt
  },
  mounted(){
    this.$store.dispatch('setLoading', false);
  },
  computed: {
    layoutName(){
      return `${this.$store.getters.layout}-layout`;
    },
    isLoading(){
      return this.$store.getters.isLoading
    }
  }
}
</script>

